import { useRouter } from "@tanstack/react-router";
import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "@/app/store";
import { ESpecialty } from "@/app/types/enumerations";

import { LanguageSelector } from "./LanguageSelector";
import { Image } from "@/components/ui/Image";
import { ParagraphBold } from "@/components/ui/typography/ParagraphBold";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { Skeleton } from "@/components/ui/skeleton";

import logoImage from "@/assets/shared/logo-horizontal.svg";

const GeneralHeader: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const { data, status } = useAppSelector((state) => state.provider);

  const name = `${data.personalData?.firstname} ${data.personalData?.surnames}`;
  const role =
    data.professionalData?.specialty &&
    data.professionalData?.specialty !== ESpecialty.OTHER
      ? t(`specialty.${data.professionalData?.specialty.toLowerCase()}`)
      : data.professionalData?.otherSpecialty;

  const handleLogoClick = () => {
    router.navigate({ to: "/dashboard" });
  };

  return (
    <header className="min-h-20 border-b border-neutral-100 flex items-center justify-between px-4">
      <Image
        src={logoImage}
        alt="MiMiAT Health"
        containerClassName="w-60"
        className="w-[50%] m-auto cursor-pointer"
        onClick={handleLogoClick}
      />

      <div className="flex items-center gap-4">
        <LanguageSelector />

        <Bell className="text-black w-6 h-6" />

        {(status === "loading" || status === "idle") && (
          <div className="flex gap-1 items-center">
            <Skeleton className="mr-2 w-10 h-10 rounded-full" />
            <div className="mr-5">
              <Skeleton className="h-5 w-32 mb-2" />
              <Skeleton className="h-4 w-24" />
            </div>
          </div>
        )}

        {status === "succeeded" && (
          <div className="flex gap-1 items-center">
            <div
              className={`mr-2 w-10 h-10 rounded-full bg-[url(/src/assets/profile/profile-others.svg)] bg-center bg-cover`}
            />
            <div className="mr-5">
              <ParagraphBold>{name}</ParagraphBold>
              <Paragraph>{role}</Paragraph>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export { GeneralHeader };
